import React from 'react';
import { palette } from '../../styles/theme';

export function ClientUnlockSVG ({ customStroke = palette.primary[700] }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g clipPath="url(#clip0_6771_12834)">
                <path d="M10.6667 9.33333C10.6667 10.7478 11.2286 12.1044 12.2288 13.1046C13.229 14.1048 14.5855 14.6667 16 14.6667C17.4145 14.6667 18.7711 14.1048 19.7713 13.1046C20.7715 12.1044 21.3334 10.7478 21.3334 9.33333C21.3334 7.91885 20.7715 6.56229 19.7713 5.5621C18.7711 4.5619 17.4145 4 16 4C14.5855 4 13.229 4.5619 12.2288 5.5621C11.2286 6.56229 10.6667 7.91885 10.6667 9.33333Z" stroke={customStroke} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 28V25.3333C8 23.9188 8.5619 22.5623 9.5621 21.5621C10.5623 20.5619 11.9188 20 13.3333 20H18.6667" stroke={customStroke} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 25.3337L22.6667 28.0003L28 22.667" stroke={customStroke} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_6771_12834">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
